import { createContext, useContext, useState } from 'react';
import translations from '../i18n';

const LangContext = createContext();

export function LangProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem('lang') || 'nl');

  function switchLang(l) {
    setLang(l);
    localStorage.setItem('lang', l);
  }

  // t('key') geeft de vertaling terug
  function t(key) {
    return translations[lang]?.[key] ?? translations['nl']?.[key] ?? key;
  }

  return (
    <LangContext.Provider value={{ lang, switchLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
